/* SuperDTF Size Guide v2.0 */
(function() {
  'use strict';

  var PRICE_PER_SQFT = 3.25;

  var SIZE_DATA = {
    tshirt: {
      placements: [
        { id: 'left-chest', label: 'Left Chest', icon: '\u25FC' },
        { id: 'right-chest', label: 'Right Chest', icon: '\u25FC' },
        { id: 'full-front', label: 'Full Front', icon: '\u25A0' },
        { id: 'full-back', label: 'Full Back', icon: '\u25A0' },
        { id: 'oversized', label: 'Oversized', icon: '\u2B1B' },
        { id: 'sleeve', label: 'Sleeve', icon: '\u25AC' },
        { id: 'pocket', label: 'Pocket Area', icon: '\u25AA' },
        { id: 'nape', label: 'Back of Neck', icon: '\u2014' }
      ],
      sizes: [
        { id: 'S', label: 'Small' },
        { id: 'M', label: 'Medium' },
        { id: 'L', label: 'Large' },
        { id: 'XL', label: 'XL' },
        { id: '2XL', label: '2XL' },
        { id: '3XL', label: '3XL' },
        { id: '4XL', label: '4XL+' }
      ]
    },
    hoodie: {
      placements: [
        { id: 'left-chest', label: 'Left Chest', icon: '\u25FC' },
        { id: 'full-front', label: 'Full Front', icon: '\u25A0' },
        { id: 'full-back', label: 'Full Back', icon: '\u25A0' },
        { id: 'oversized', label: 'Oversized', icon: '\u2B1B' },
        { id: 'sleeve', label: 'Sleeve', icon: '\u25AC' },
        { id: 'hood', label: 'Hood', icon: '\u25B2' },
        { id: 'kangaroo', label: 'Kangaroo Pocket', icon: '\u25AC' }
      ],
      sizes: [
        { id: 'S', label: 'Small' },
        { id: 'M', label: 'Medium' },
        { id: 'L', label: 'Large' },
        { id: 'XL', label: 'XL' },
        { id: '2XL', label: '2XL' },
        { id: '3XL', label: '3XL' }
      ]
    },
    youth: {
      placements: [
        { id: 'left-chest', label: 'Left Chest', icon: '\u25FC' },
        { id: 'full-front', label: 'Full Front', icon: '\u25A0' },
        { id: 'full-back', label: 'Full Back', icon: '\u25A0' },
        { id: 'sleeve', label: 'Sleeve', icon: '\u25AC' }
      ],
      sizes: [
        { id: 'YS', label: 'Youth S (6-7)' },
        { id: 'YM', label: 'Youth M (8-10)' },
        { id: 'YL', label: 'Youth L (12-14)' },
        { id: 'YXL', label: 'Youth XL (16-18)' }
      ]
    },
    hat: {
      placements: [
        { id: 'hat-front', label: 'Front Panel', icon: '\u25A0' }
      ],
      sizes: [
        { id: 'OS', label: 'One Size' }
      ]
    },
    bag: {
      placements: [
        { id: 'bag-center', label: 'Center', icon: '\u25A0' },
        { id: 'bag-full', label: 'Full Coverage', icon: '\u2B1B' },
        { id: 'bag-small', label: 'Small Logo', icon: '\u25FC' }
      ],
      sizes: [
        { id: 'standard', label: 'Standard Tote' },
        { id: 'large', label: 'Large / Grocery' }
      ]
    },
    other: {
      placements: [
        { id: 'custom-sm', label: 'Small (under 5")', icon: '\u25FC' },
        { id: 'custom-md', label: 'Medium (5-10")', icon: '\u25A0' },
        { id: 'custom-lg', label: 'Large (10-16")', icon: '\u2B1B' },
        { id: 'custom-xl', label: 'XL (16"+)', icon: '\u2B1C' }
      ],
      sizes: [
        { id: 'any', label: 'Any / Custom' }
      ]
    }
  };

  var RECS = {
    tshirt: {
      'left-chest':  { S: [3,3], M: [3.5,3.5], L: [3.5,3.5], XL: [4,4], '2XL': [4,4], '3XL': [4.5,4.5], '4XL': [4.5,4.5] },
      'right-chest': { S: [3,3], M: [3.5,3.5], L: [3.5,3.5], XL: [4,4], '2XL': [4,4], '3XL': [4.5,4.5], '4XL': [4.5,4.5] },
      'full-front':  { S: [9,11], M: [10,12], L: [11,13], XL: [11,14], '2XL': [12,14], '3XL': [12,15], '4XL': [13,15] },
      'full-back':   { S: [10,12], M: [11,13], L: [12,14], XL: [12,15], '2XL': [13,15], '3XL': [14,16], '4XL': [14,16] },
      'oversized':   { S: [12,14], M: [13,15], L: [14,16], XL: [15,17], '2XL': [16,18], '3XL': [17,19], '4XL': [18,20] },
      'sleeve':      { S: [3,10], M: [3,11], L: [3.5,12], XL: [3.5,12], '2XL': [4,13], '3XL': [4,13], '4XL': [4,14] },
      'pocket':      { S: [2.5,2.5], M: [3,3], L: [3,3], XL: [3,3], '2XL': [3.5,3.5], '3XL': [3.5,3.5], '4XL': [3.5,3.5] },
      'nape':        { S: [2,1], M: [2.5,1], L: [3,1.5], XL: [3,1.5], '2XL': [3,1.5], '3XL': [3.5,1.5], '4XL': [3.5,1.5] }
    },
    hoodie: {
      // Based on Gildan 18500: S=20"w/27"L, M=22"w/28"L, L=24"w/29"L, XL=26"w/30"L, 2XL=28"w/31"L, 3XL=30"w/32"L
      // Full front: 3" below collar to above pocket (~7-9" printable height depending on size)
      'left-chest':  { S: [3,3], M: [3.5,3.5], L: [3.5,3.5], XL: [4,4], '2XL': [4,4], '3XL': [4.5,4.5] },
      'full-front':  { S: [9,10], M: [10,11], L: [11,12], XL: [11,13], '2XL': [12,13], '3XL': [12,14] },
      'full-back':   { S: [10,12], M: [11,13], L: [12,14], XL: [13,15], '2XL': [14,16], '3XL': [14,17] },
      'oversized':   { S: [12,13], M: [13,14], L: [14,15], XL: [15,16], '2XL': [16,17], '3XL': [17,18] },
      'sleeve':      { S: [3,12], M: [3.5,13], L: [3.5,14], XL: [4,14], '2XL': [4,15], '3XL': [4,15] },
      'hood':        { S: [4,3], M: [4,3], L: [5,4], XL: [5,4], '2XL': [5,4], '3XL': [6,4] },
      'kangaroo':    { S: [8,4], M: [9,4], L: [10,5], XL: [10,5], '2XL': [11,5], '3XL': [11,5] }
    },
    youth: {
      'left-chest': { YS: [2.5,2.5], YM: [2.5,2.5], YL: [3,3], YXL: [3,3] },
      'full-front': { YS: [7,8], YM: [7.5,9], YL: [8,10], YXL: [9,11] },
      'full-back':  { YS: [7,9], YM: [8,10], YL: [9,11], YXL: [9,11] },
      'sleeve':     { YS: [2,7], YM: [2.5,8], YL: [2.5,9], YXL: [3,10] }
    },
    hat: {
      'hat-front': { OS: [4,2.5] }
    },
    bag: {
      'bag-center': { standard: [8,8], large: [10,10] },
      'bag-full':   { standard: [12,14], large: [14,16] },
      'bag-small':  { standard: [4,4], large: [4,4] }
    },
    other: {
      'custom-sm': { any: [4,4] },
      'custom-md': { any: [8,8] },
      'custom-lg': { any: [12,14] },
      'custom-xl': { any: [18,20] }
    }
  };

  var CHART_ROWS = [
    { placement: 'Left Chest', w: 3.5, h: 3.5, garment: 'tshirt', gLabel: 'T-Shirt', size: 'S-XL', popular: true },
    { placement: 'Left Chest', w: 4, h: 4, garment: 'tshirt', gLabel: 'T-Shirt', size: '2XL-4XL' },
    { placement: 'Right Chest', w: 3.5, h: 3.5, garment: 'tshirt', gLabel: 'T-Shirt', size: 'S-XL' },
    { placement: 'Pocket Area', w: 3, h: 3, garment: 'tshirt', gLabel: 'T-Shirt', size: 'All' },
    { placement: 'Full Front', w: 10, h: 12, garment: 'tshirt', gLabel: 'T-Shirt', size: 'S-M' },
    { placement: 'Full Front', w: 11, h: 14, garment: 'tshirt', gLabel: 'T-Shirt', size: 'L-XL', popular: true },
    { placement: 'Full Front', w: 12, h: 14, garment: 'tshirt', gLabel: 'T-Shirt', size: '2XL-4XL' },
    { placement: 'Full Back', w: 11, h: 13, garment: 'tshirt', gLabel: 'T-Shirt', size: 'S-M' },
    { placement: 'Full Back', w: 12, h: 14, garment: 'tshirt', gLabel: 'T-Shirt', size: 'L-XL', popular: true },
    { placement: 'Full Back', w: 14, h: 16, garment: 'tshirt', gLabel: 'T-Shirt', size: '2XL-4XL' },
    { placement: 'Oversized Front', w: 14, h: 16, garment: 'tshirt', gLabel: 'T-Shirt', size: 'L-XL', popular: true },
    { placement: 'Oversized Front', w: 16, h: 18, garment: 'tshirt', gLabel: 'T-Shirt', size: '2XL+' },
    { placement: 'Sleeve', w: 3.5, h: 12, garment: 'tshirt', gLabel: 'T-Shirt', size: 'L-XL' },
    { placement: 'Back of Neck', w: 3, h: 1.5, garment: 'tshirt', gLabel: 'T-Shirt', size: 'All' },
    { placement: 'Left Chest', w: 4, h: 4, garment: 'hoodie', gLabel: 'Hoodie', size: 'S-XL' },
    { placement: 'Full Front', w: 11, h: 14, garment: 'hoodie', gLabel: 'Hoodie', size: 'S-L', popular: true },
    { placement: 'Full Front', w: 13, h: 15, garment: 'hoodie', gLabel: 'Hoodie', size: 'XL-3XL' },
    { placement: 'Full Back', w: 12, h: 15, garment: 'hoodie', gLabel: 'Hoodie', size: 'S-L' },
    { placement: 'Full Back', w: 14, h: 16, garment: 'hoodie', gLabel: 'Hoodie', size: 'XL-3XL', popular: true },
    { placement: 'Oversized Front', w: 15, h: 17, garment: 'hoodie', gLabel: 'Hoodie', size: 'L-XL' },
    { placement: 'Sleeve', w: 3.5, h: 14, garment: 'hoodie', gLabel: 'Hoodie', size: 'L-XL' },
    { placement: 'Hood', w: 5, h: 4, garment: 'hoodie', gLabel: 'Hoodie', size: 'All' },
    { placement: 'Kangaroo Pocket', w: 10, h: 5, garment: 'hoodie', gLabel: 'Hoodie', size: 'L-XL' },
    { placement: 'Full Front', w: 7.5, h: 9, garment: 'youth', gLabel: 'Youth', size: 'YS-YM' },
    { placement: 'Full Front', w: 9, h: 11, garment: 'youth', gLabel: 'Youth', size: 'YL-YXL', popular: true },
    { placement: 'Full Back', w: 8, h: 10, garment: 'youth', gLabel: 'Youth', size: 'YS-YM' },
    { placement: 'Full Back', w: 9, h: 11, garment: 'youth', gLabel: 'Youth', size: 'YL-YXL' },
    { placement: 'Left Chest', w: 2.5, h: 2.5, garment: 'youth', gLabel: 'Youth', size: 'YS-YM' },
    { placement: 'Left Chest', w: 3, h: 3, garment: 'youth', gLabel: 'Youth', size: 'YL-YXL' },
    { placement: 'Front Panel', w: 4, h: 2.5, garment: 'hat', gLabel: 'Hat / Cap', size: 'One Size', popular: true },
    { placement: 'Center', w: 8, h: 8, garment: 'bag', gLabel: 'Tote Bag', size: 'Standard' },
    { placement: 'Center', w: 10, h: 10, garment: 'bag', gLabel: 'Tote Bag', size: 'Large', popular: true },
    { placement: 'Full Coverage', w: 14, h: 16, garment: 'bag', gLabel: 'Tote Bag', size: 'Large' },
    { placement: 'Small Logo', w: 4, h: 4, garment: 'bag', gLabel: 'Tote Bag', size: 'All' }
  ];

  // Average blank garment costs (wholesale)
  var BLANK_COSTS = {
    tshirt: 3.50, hoodie: 12.00, youth: 3.00, hat: 4.00, bag: 2.00, other: 5.00
  };

  // Average retail prices by garment + placement type
  var AVG_RETAIL = {
    tshirt:  { 'left-chest': 20, 'right-chest': 20, 'full-front': 25, 'full-back': 25, 'oversized': 30, 'sleeve': 22, 'pocket': 20, 'nape': 20, _default: 25 },
    hoodie:  { 'left-chest': 38, 'full-front': 42, 'full-back': 42, 'oversized': 48, 'sleeve': 40, 'hood': 40, 'kangaroo': 40, _default: 42 },
    youth:   { 'left-chest': 16, 'full-front': 20, 'full-back': 20, 'sleeve': 18, _default: 18 },
    hat:     { 'hat-front': 22, _default: 22 },
    bag:     { 'bag-center': 18, 'bag-full': 22, 'bag-small': 15, _default: 18 },
    other:   { _default: 25 }
  };

  function getAvgRetail(garment, placement) {
    var g = AVG_RETAIL[garment] || AVG_RETAIL.other;
    return g[placement] || g._default || 25;
  }

  var state = { step: 1, garment: null, placement: null, garmentSize: null };

  // Profit calculator state
  var calcState = {
    garment: 'tshirt',
    blankCost: 3.50,
    placements: [],
    miscFees: [],
    quantity: 1
  };
  var calcIdCounter = 0;

  function calcPrice(w, h) {
    var sqft = (w * h) / 144;
    return (sqft * PRICE_PER_SQFT).toFixed(2);
  }

  function calcSqFt(w, h) {
    return ((w * h) / 144).toFixed(2);
  }

  function showStep(n) {
    state.step = n;
    document.querySelectorAll('.superdtf-sg-wizard-step').forEach(function(el) {
      el.classList.toggle('is-active', el.dataset.sgWizard == n);
    });
    document.querySelectorAll('.superdtf-sg-step-indicator').forEach(function(dot) {
      var dotN = parseInt(dot.dataset.sgStepDot);
      dot.classList.toggle('is-active', dotN === n);
      dot.classList.toggle('is-done', dotN < n);
    });
    document.querySelectorAll('.superdtf-sg-step-line').forEach(function(line) {
      line.classList.toggle('is-done', parseInt(line.dataset.sgStepLine) < n);
    });
  }

  function renderPlacements() {
    var container = document.getElementById('sg-placement-options');
    var data = SIZE_DATA[state.garment];
    if (!data) return;
    var html = '';
    data.placements.forEach(function(p) {
      html += '<button class="superdtf-sg-option" data-sg-placement="' + p.id + '" style="color: inherit;">'
            + '<span class="superdtf-sg-option-icon">' + p.icon + '</span>'
            + '<span class="superdtf-sg-option-label">' + p.label + '</span>'
            + '</button>';
    });
    container.innerHTML = html;
    bindOptionClicks(container, function(btn) {
      state.placement = btn.dataset.sgPlacement;
      if (SIZE_DATA[state.garment].sizes.length === 1) {
        state.garmentSize = SIZE_DATA[state.garment].sizes[0].id;
        showResult();
        showStep(4);
      } else {
        renderSizes();
        showStep(3);
      }
    });
  }

  function renderSizes() {
    var container = document.getElementById('sg-size-options');
    var data = SIZE_DATA[state.garment];
    if (!data) return;
    var html = '';
    data.sizes.forEach(function(s) {
      html += '<button class="superdtf-sg-option" data-sg-gsize="' + s.id + '" style="color: inherit;">'
            + '<span class="superdtf-sg-option-label" style="font-size:18px;font-weight:700;">' + s.id + '</span>'
            + '<span class="superdtf-sg-option-sub">' + s.label + '</span>'
            + '</button>';
    });
    container.innerHTML = html;
    bindOptionClicks(container, function(btn) {
      state.garmentSize = btn.dataset.sgGsize;
      showResult();
      showStep(4);
    });
  }

  function showResult() {
    var rec = RECS[state.garment] && RECS[state.garment][state.placement];
    if (!rec) return;
    var dims = rec[state.garmentSize] || rec[Object.keys(rec)[0]];
    var w = dims[0], h = dims[1];
    document.getElementById('sg-result-size').textContent = w + '" \u00D7 ' + h + '"';
    var placementLabel = '';
    var data = SIZE_DATA[state.garment];
    data.placements.forEach(function(p) { if (p.id === state.placement) placementLabel = p.label; });
    var garmentLabels = { tshirt: 'T-Shirt', hoodie: 'Hoodie', youth: 'Youth', hat: 'Hat', bag: 'Tote Bag', other: 'Custom' };
    document.getElementById('sg-result-desc').textContent = placementLabel + ' on ' + (garmentLabels[state.garment] || 'Garment') + ' (' + state.garmentSize + ')';
    document.getElementById('sg-result-sqin').textContent = (w * h).toFixed(0);
    document.getElementById('sg-result-sqft').textContent = calcSqFt(w, h);
    document.getElementById('sg-result-price').textContent = '$' + calcPrice(w, h);

    var visualEl = document.getElementById('sg-result-visual');
    visualEl.innerHTML = buildVisualSVG(state.garment, state.placement, w, h);
  }

  function buildVisualSVG(garment, placement, w, h) {
    var mockups = window.SUPERDTF_SG_MOCKUPS || {};
    var label = w + '" \u00D7 ' + h + '"';

    // Pick the right mockup view based on placement
    var isBack = placement === 'full-back' || placement === 'nape' || placement === 'hood';
    var isSleeve = placement === 'sleeve';

    var imgSrc;
    if (garment === 'hat') {
      imgSrc = mockups.hat;
    } else if (garment === 'bag') {
      imgSrc = mockups.tote;
    } else if (garment === 'hoodie') {
      if (isBack) imgSrc = mockups.hoodieBack;
      else if (isSleeve) imgSrc = mockups.hoodieSide;
      else imgSrc = mockups.hoodie;
    } else {
      if (isBack) imgSrc = mockups.tshirtBack;
      else if (isSleeve) imgSrc = mockups.tshirtSide;
      else imgSrc = mockups.tshirt;
    }

    // Dynamic box sizing: compute CSS % from real inch dimensions
    // Each placement defines a center point (%) and the garment's real-world
    // reference size visible in the image, so we can convert inches to %.
    // imgRefW/H = how many real inches the full image width/height represents

    var zones = {
      tshirt: {
        // Front view: image shows ~26" wide garment area, ~38" tall (shoulder to below hem with padding)
        'left-chest':  { cx: 37, cy: 40, refW: 26, refH: 38 },
        'right-chest': { cx: 63, cy: 40, refW: 26, refH: 38 },
        'full-front':  { cx: 50, cy: 48, refW: 26, refH: 38 },
        'full-back':   { cx: 50, cy: 48, refW: 26, refH: 38 },
        'oversized':   { cx: 50, cy: 45, refW: 26, refH: 38 },
        'sleeve':      { cx: 42, cy: 40, refW: 14, refH: 38 },
        'pocket':      { cx: 37, cy: 40, refW: 26, refH: 38 },
        'nape':        { cx: 50, cy: 24, refW: 26, refH: 38 }
      },
      hoodie: {
        // Front view: ~28" wide, ~40" tall
        'left-chest':  { cx: 37, cy: 40, refW: 28, refH: 40 },
        'full-front':  { cx: 50, cy: 46, refW: 28, refH: 40 },
        'full-back':   { cx: 50, cy: 46, refW: 28, refH: 40 },
        'oversized':   { cx: 50, cy: 44, refW: 28, refH: 40 },
        'sleeve':      { cx: 44, cy: 48, refW: 14, refH: 40 },
        'hood':        { cx: 50, cy: 14, refW: 28, refH: 40 },
        'kangaroo':    { cx: 50, cy: 67, refW: 28, refH: 40 }
      },
      hat: {
        // Front panel: ~10" wide panel, ~8" tall visible
        'hat-front':   { cx: 50, cy: 34, refW: 10, refH: 12 }
      },
      bag: {
        // Tote: ~16" wide, ~18" tall
        'bag-center':  { cx: 50, cy: 56, refW: 16, refH: 22 },
        'bag-full':    { cx: 50, cy: 56, refW: 16, refH: 22 },
        'bag-small':   { cx: 50, cy: 56, refW: 16, refH: 22 }
      }
    };
    zones.youth = zones.tshirt;
    zones.other = zones.tshirt;

    var garmentZones = zones[garment] || zones.tshirt;
    var zone = garmentZones[placement] || { cx: 50, cy: 45, refW: 26, refH: 38 };

    // Convert inches to % of image
    var boxW = (w / zone.refW) * 100;
    var boxH = (h / zone.refH) * 100;
    var boxL = zone.cx - boxW / 2;
    var boxT = zone.cy - boxH / 2;

    return '<div style="position:relative;display:inline-block;max-width:280px;width:100%;">'
      + '<img src="' + imgSrc + '" alt="Garment mockup" style="width:100%;height:auto;border-radius:12px;display:block;">'
      + '<div style="position:absolute;left:' + boxL.toFixed(1) + '%;top:' + boxT.toFixed(1) + '%;width:' + boxW.toFixed(1) + '%;height:' + boxH.toFixed(1) + '%;border:2px dashed #00e5ff;background:rgba(0,229,255,0.12);border-radius:4px;display:flex;align-items:center;justify-content:center;">'
      + '<span style="color:#00e5ff;font-size:clamp(10px,2.5vw,14px);font-weight:700;text-shadow:0 1px 3px rgba(0,0,0,0.8);">' + label + '</span>'
      + '</div>'
      + '</div>';
  }

  function bindOptionClicks(container, callback) {
    container.querySelectorAll('.superdtf-sg-option').forEach(function(btn) {
      btn.addEventListener('click', function() {
        container.querySelectorAll('.superdtf-sg-option').forEach(function(b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        setTimeout(function() { callback(btn); }, 200);
      });
    });
  }

  function renderChart() {
    var tbody = document.getElementById('sg-chart-body');
    if (!tbody) return;
    var html = '';
    CHART_ROWS.forEach(function(row) {
      var sqin = row.w * row.h;
      var dtfCost = parseFloat(calcPrice(row.w, row.h));
      var blankCost = BLANK_COSTS[row.garment] || 5;
      var placementKey = row.placement.toLowerCase().replace(/ /g, '-').replace('oversized-front', 'oversized').replace('back-of-neck', 'nape').replace('front-panel', 'hat-front').replace('small-logo', 'bag-small').replace('full-coverage', 'bag-full');
      var avgRetail = getAvgRetail(row.garment, placementKey);
      var totalCost = dtfCost + blankCost;
      var profit = avgRetail - totalCost;
      var badgeClass = 'sg-badge-' + row.garment;
      html += '<tr data-sg-cat="' + row.garment + '">'
        + '<td class="sg-placement">' + row.placement + (row.popular ? '<span class="sg-popular">Popular</span>' : '') + '</td>'
        + '<td class="sg-size">' + row.w + '" \u00D7 ' + row.h + '"</td>'
        + '<td><span class="sg-category-badge ' + badgeClass + '">' + row.gLabel + '</span></td>'
        + '<td>' + row.size + '</td>'
        + '<td class="sg-price">$' + dtfCost.toFixed(2) + '</td>'
        + '<td style="opacity:0.6;">$' + avgRetail.toFixed(0) + '</td>'
        + '<td class="sg-profit">$' + profit.toFixed(2) + '</td>'
        + '</tr>';
    });
    tbody.innerHTML = html;
  }


  function init() {
    var section = document.getElementById('superdtf-size-guide');
    if (!section) return;

    section.querySelectorAll('.superdtf-sg-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        section.querySelectorAll('.superdtf-sg-tab').forEach(function(t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var mode = tab.dataset.sgMode;
        section.querySelectorAll('.superdtf-sg-panel').forEach(function(p) { p.classList.remove('is-active'); });
        section.querySelector('[data-sg-panel="' + mode + '"]').classList.add('is-active');
      });
    });

    var step1 = section.querySelector('[data-sg-wizard="1"]');
    if (step1) {
      bindOptionClicks(step1, function(btn) {
        state.garment = btn.dataset.sgGarment;
        state.placement = null;
        state.garmentSize = null;
        renderPlacements();
        showStep(2);
      });
    }

    section.querySelectorAll('[data-sg-back]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (state.step > 1) showStep(state.step - 1);
      });
    });

    section.querySelectorAll('[data-sg-restart]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        state = { step: 1, garment: null, placement: null, garmentSize: null };
        section.querySelectorAll('.superdtf-sg-option').forEach(function(o) { o.classList.remove('is-selected'); });
        showStep(1);
      });
    });

    section.querySelectorAll('.superdtf-sg-chart-filter').forEach(function(btn) {
      btn.addEventListener('click', function() {
        section.querySelectorAll('.superdtf-sg-chart-filter').forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var filter = btn.dataset.sgFilter;
        section.querySelectorAll('#sg-chart-body tr').forEach(function(tr) {
          if (filter === 'all') {
            tr.classList.remove('is-hidden');
          } else {
            tr.classList.toggle('is-hidden', tr.dataset.sgCat !== filter);
          }
        });
      });
    });

    renderChart();
    initProfitCalc();
  }

  function initProfitCalc() {
    var PPF = 3.25;
    var BL = {tshirt:3.5,hoodie:12,youth:3,hat:4,bag:2};
    var PL = {
      tshirt:["Left Chest","Right Chest","Full Front","Full Back","Oversized","Sleeve","Pocket Area","Back of Neck"],
      hoodie:["Left Chest","Full Front","Full Back","Oversized","Sleeve","Hood","Kangaroo Pocket"],
      youth:["Left Chest","Full Front","Full Back","Sleeve"],
      hat:["Front Panel"],
      bag:["Center","Full Coverage","Small Logo"]
    };
    var gs = document.getElementById("pc-garment");
    var bi = document.getElementById("pc-blank");
    var addBtn = document.getElementById("pc-add-p");
    var addFBtn = document.getElementById("pc-add-f");
    var pdfBtn = document.getElementById("pc-pdf");
    if (!gs) return;

    function cp(w,h) { return parseFloat(((w*h)/144*PPF).toFixed(2)); }
    function mkOpts(g) { return (PL[g]||PL.tshirt).map(function(p){ return "<option>"+p+"<\/option>"; }).join(""); }

    function addRow() {
      var c = document.getElementById("pc-placements");
      var d = document.createElement("div");
      d.style.cssText = "display:flex;align-items:center;gap:10px;margin-bottom:8px;padding:12px 16px;background:#111;border:1px solid #333;border-radius:8px;";
      d.innerHTML = "<select style='flex:1;padding:8px;background:#1a1a1a;color:#fff;border:1px solid #444;border-radius:6px;font-size:14px;'>" + mkOpts(gs.value) + "<\/select>"
        + "<input type='number' value='11' step='0.5' min='0.5' style='width:60px;padding:8px;background:#1a1a1a;color:#fff;border:1px solid #444;border-radius:6px;text-align:center;font-size:14px;'>"
        + "<span style='color:#555;'>x<\/span>"
        + "<input type='number' value='14' step='0.5' min='0.5' style='width:60px;padding:8px;background:#1a1a1a;color:#fff;border:1px solid #444;border-radius:6px;text-align:center;font-size:14px;'>"
        + "<span style='color:#fcee01;font-weight:700;min-width:55px;text-align:right;font-size:14px;' data-cost>$0.00<\/span>"
        + "<button style='background:none;border:none;color:#555;font-size:18px;cursor:pointer;padding:4px 8px;' data-rm>X<\/button>";
      c.appendChild(d);
      d.querySelector("[data-rm]").addEventListener("click", function(){ d.remove(); recalc(); });
      d.querySelectorAll("input,select").forEach(function(el){ el.addEventListener("input", recalc); el.addEventListener("change", recalc); });
      recalc();
    }

    function addFee() {
      var c = document.getElementById("pc-fees");
      var d = document.createElement("div");
      d.style.cssText = "display:flex;align-items:center;gap:10px;margin-bottom:8px;padding:12px 16px;background:#111;border:1px solid #333;border-radius:8px;";
      d.innerHTML = "<input type='text' placeholder='Fee name (Labor, Packaging...)' style='flex:1;padding:8px;background:#1a1a1a;color:#fff;border:1px solid #444;border-radius:6px;font-size:14px;'>"
        + "<input type='number' value='2.00' step='0.25' min='0' style='width:80px;padding:8px;background:#1a1a1a;color:#fff;border:1px solid #444;border-radius:6px;text-align:center;font-size:14px;'>"
        + "<button style='background:none;border:none;color:#555;font-size:18px;cursor:pointer;padding:4px 8px;' data-rm>X<\/button>";
      c.appendChild(d);
      d.querySelector("[data-rm]").addEventListener("click", function(){ d.remove(); recalc(); });
      d.querySelectorAll("input").forEach(function(el){ el.addEventListener("input", recalc); });
      recalc();
    }

    function recalc() {
      var bl = parseFloat(bi.value) || 0;
      var qty = parseInt(document.getElementById("pc-qty").value) || 1;
      var tt = 0;
      document.querySelectorAll("#pc-placements > div").forEach(function(r) {
        var ins = r.querySelectorAll("input[type=number]");
        var w = parseFloat(ins[0].value) || 0;
        var h = parseFloat(ins[1].value) || 0;
        var c = cp(w,h); tt += c;
        r.querySelector("[data-cost]").textContent = "$" + c.toFixed(2);
      });
      var tf = 0;
      document.querySelectorAll("#pc-fees > div").forEach(function(r) {
        var ins = r.querySelectorAll("input[type=number]");
        if (ins.length) tf += parseFloat(ins[0].value) || 0;
      });
      var cpu = bl + tt + tf;
      var s = document.getElementById("pc-summary");
      var mk = [{l:"50%",m:1.5},{l:"100%",m:2},{l:"150%",m:2.5},{l:"200%",m:3}];
      var h = "<div style='display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:16px;'>"
        + "<div style='display:flex;justify-content:space-between;padding:12px 16px;background:#111;border-radius:8px;'><span style='color:#999;font-size:13px;'>Blank Garment<\/span><span style='color:#fff;font-weight:600;'>$"+bl.toFixed(2)+"<\/span><\/div>"
        + "<div style='display:flex;justify-content:space-between;padding:12px 16px;background:#111;border-radius:8px;'><span style='color:#999;font-size:13px;'>DTF Transfers<\/span><span style='color:#fff;font-weight:600;'>$"+tt.toFixed(2)+"<\/span><\/div>"
        + "<div style='display:flex;justify-content:space-between;padding:12px 16px;background:#111;border-radius:8px;'><span style='color:#999;font-size:13px;'>Misc Fees<\/span><span style='color:#fff;font-weight:600;'>$"+tf.toFixed(2)+"<\/span><\/div>"
        + "<div style='display:flex;justify-content:space-between;padding:12px 16px;background:rgba(0,229,255,0.08);border:1px solid rgba(0,229,255,0.3);border-radius:8px;'><span style='color:#fff;font-weight:600;'>Total Cost / Unit<\/span><span style='color:#00e5ff;font-weight:700;font-size:18px;'>$"+cpu.toFixed(2)+"<\/span><\/div>"
        + "<\/div>";
      if (qty > 1) h += "<div style='text-align:center;color:#999;font-size:14px;margin-bottom:16px;'>Batch cost ("+qty+" units): <strong style='color:#fcee01;'>$"+(cpu*qty).toFixed(2)+"<\/strong><\/div>";
      h += "<div style='font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:1px;color:#00e5ff;margin:24px 0 12px;'>Suggested Retail Pricing<\/div><div style='display:grid;grid-template-columns:repeat(4,1fr);gap:10px;'>";
      mk.forEach(function(x) {
        var rp=cpu*x.m, pr=rp-cpu;
        h += "<div style='text-align:center;padding:16px 8px;background:#111;border:1px solid #333;border-radius:8px;'><div style='font-size:11px;text-transform:uppercase;color:#666;margin-bottom:6px;'>"+x.l+" markup<\/div><div style='font-size:22px;font-weight:700;color:#fcee01;'>$"+rp.toFixed(2)+"<\/div><div style='font-size:12px;color:#00cc66;margin-top:4px;'>$"+pr.toFixed(2)+" profit<\/div>"+(qty>1?"<div style='font-size:11px;color:#666;margin-top:2px;'>$"+(pr*qty).toFixed(2)+" total<\/div>":"")+"<\/div>";
      });
      h += "<\/div><div style='margin-top:20px;padding:16px;background:#111;border-radius:8px;'><div style='font-size:13px;color:#999;margin-bottom:6px;'>Set your own price:<\/div><div style='display:flex;align-items:center;gap:8px;'><span style='font-size:18px;color:#fcee01;'>$<\/span><input type='number' id='pc-custom' value='"+(cpu*2.5).toFixed(2)+"' step='0.50' min='0' style='width:100px;padding:8px;background:#1a1a1a;color:#fff;border:1px solid #444;border-radius:6px;font-size:15px;'><span id='pc-custom-r' style='font-size:14px;'><\/span><\/div><\/div>";
      s.innerHTML = h;
      var ci = document.getElementById("pc-custom");
      if (ci) {
        var uc = function() {
          var rr=parseFloat(ci.value)||0, pp=rr-cpu, pct=cpu>0?((pp/cpu)*100).toFixed(0):0;
          var re=document.getElementById("pc-custom-r");
          if(re){re.textContent=pp>=0?"$"+pp.toFixed(2)+" profit ("+pct+"% markup)"+(qty>1?" | $"+(pp*qty).toFixed(2)+" total":""):"-$"+Math.abs(pp).toFixed(2)+" loss";re.style.color=pp>=0?"#00cc66":"#ff4444";}
        };
        ci.addEventListener("input", uc); uc();
      }
    }

    gs.addEventListener("change", function() {
      bi.value = (BL[gs.value]||5).toFixed(2);
      document.querySelectorAll("#pc-placements > div select").forEach(function(sel) {
        var v = sel.value; sel.innerHTML = mkOpts(gs.value);
        for(var i=0;i<sel.options.length;i++){if(sel.options[i].text===v){sel.selectedIndex=i;break;}}
      });
      recalc();
    });
    bi.addEventListener("input", recalc);
    document.getElementById("pc-qty").addEventListener("input", recalc);
    if (addBtn) addBtn.addEventListener("click", addRow);
    if (addFBtn) addFBtn.addEventListener("click", addFee);

    // Wire up the existing first row
    var firstRow = document.querySelector("#pc-placements > div");
    if (firstRow) {
      var rmBtn = firstRow.querySelector("[data-rm]");
      if (rmBtn) rmBtn.addEventListener("click", function(){ firstRow.remove(); recalc(); });
      firstRow.querySelectorAll("input,select").forEach(function(el){ el.addEventListener("input", recalc); el.addEventListener("change", recalc); });
    }

    if (pdfBtn) pdfBtn.addEventListener("click", function() {
      var bl=parseFloat(bi.value)||0, qty=parseInt(document.getElementById("pc-qty").value)||1;
      var gn=gs.options[gs.selectedIndex].text, pls=[], tt=0;
      document.querySelectorAll("#pc-placements > div").forEach(function(r){
        var se=r.querySelector("select"), ins=r.querySelectorAll("input[type=number]");
        var w=parseFloat(ins[0].value)||0, hh=parseFloat(ins[1].value)||0, c=cp(w,hh); tt+=c;
        pls.push({n:se.options[se.selectedIndex].text,w:w,h:hh,c:c});
      });
      var fees=[], tff=0;
      document.querySelectorAll("#pc-fees > div").forEach(function(r){
        var ins=r.querySelectorAll("input");
        var n=ins[0]?ins[0].value||"Fee":"Fee", a=ins[1]?parseFloat(ins[1].value)||0:0; tff+=a; fees.push({n:n,a:a});
      });
      var cpu=bl+tt+tff, dd=new Date().toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"});
      var p="<!DOCTYPE html><html><head><title>SuperDTF Pricing Estimate<\/title><style>body{font-family:-apple-system,sans-serif;max-width:700px;margin:40px auto;color:#333;}h1{font-size:24px;margin-bottom:4px;}table{width:100%;border-collapse:collapse;margin:16px 0;}th,td{padding:10px 12px;text-align:left;border-bottom:1px solid #eee;}th{background:#f8f8f8;font-size:12px;text-transform:uppercase;color:#666;}.t td{font-weight:700;border-top:2px solid #333;}.g{color:#00884d;font-weight:700;}.f{margin-top:40px;border-top:1px solid #eee;padding-top:16px;font-size:12px;color:#999;}<\/style><\/head><body>";
      p+="<h1>SuperDTF Pricing Estimate<\/h1><p style='color:#666;font-size:14px;margin-bottom:30px;'>"+dd+" | superdtf.com<\/p>";
      p+="<p><strong>Garment:<\/strong> "+gn+" | <strong>Qty:<\/strong> "+qty+"<\/p>";
      p+="<table><thead><tr><th>Item<\/th><th>Details<\/th><th style='text-align:right;'>Cost<\/th><\/tr><\/thead><tbody>";
      p+="<tr><td>Blank<\/td><td>"+gn+"<\/td><td style='text-align:right;'>$"+bl.toFixed(2)+"<\/td><\/tr>";
      pls.forEach(function(x){p+="<tr><td>DTF Transfer<\/td><td>"+x.n+" ("+x.w+"\\\" x "+x.h+"\\\")<\/td><td style='text-align:right;'>$"+x.c.toFixed(2)+"<\/td><\/tr>";});
      fees.forEach(function(x){p+="<tr><td>"+x.n+"<\/td><td><\/td><td style='text-align:right;'>$"+x.a.toFixed(2)+"<\/td><\/tr>";});
      p+="<tr class='t'><td>Total Cost / Unit<\/td><td><\/td><td style='text-align:right;'>$"+cpu.toFixed(2)+"<\/td><\/tr><\/tbody><\/table>";
      p+="<h3>Pricing<\/h3><table><thead><tr><th>Retail<\/th><th>Profit<\/th><th>Markup<\/th>"+(qty>1?"<th>Total ("+qty+")<\/th>":"")+"<\/tr><\/thead><tbody>";
      [1.5,2,2.5,3,3.5,4].forEach(function(m){var rr=cpu*m,pp=rr-cpu,pc=((pp/cpu)*100).toFixed(0);p+="<tr><td>$"+rr.toFixed(2)+"<\/td><td class='g'>$"+pp.toFixed(2)+"<\/td><td>"+pc+"%<\/td>"+(qty>1?"<td class='g'>$"+(pp*qty).toFixed(2)+"<\/td>":"")+"<\/tr>";});
      p+="<\/tbody><\/table><div class='f'>SuperDTF | superdtf.com<\/div><\/body><\/html>";
      var wn=window.open("","_blank");wn.document.write(p);wn.document.close();setTimeout(function(){wn.print();},500);
    });

    recalc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
